export default {
  data() {
    return {
      loading: false,
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: total =>
          `共 ${total} 条记录 第${this.pagination.current}/${Math.ceil(total / this.pagination.pageSize)} 页`
      },
      selectedRows: [],
      selectedRowKeys: []
    }
  },
  methods: {
    handleSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRows
      this.selectedRowKeys = selectedRowKeys
    },
    handlePageChange(pagination) {
      this.pagination = pagination
      if (this.getTableData) {
        this.getTableData()
      }
    }
  }
}
